import { nextArrow, prevArrow, options } from "@/global/slick-options";

jQuery( '.big-slider-slider' ).slick( {
    ...options,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '20%',
    arrows: true,
    rows: 0,
    prevArrow,
    nextArrow,
} );
